var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { identity, omit, pickBy } from "lodash";
import { isSSR } from "./../../wix-rich-content-common";
function paramsToBiFields(essentials) {
  const {
    bsi,
    metaSiteId: msid,
    visitorId: _visitorId,
    appId: _appId,
    instanceId: _instanceId,
    siteOwnerId: _siteOwnerId
  } = essentials;
  return pickBy({ bsi, msid, _visitorId, _appId, _instanceId, _siteOwnerId }, identity);
}
class RicosBILogger {
  constructor({ logger, webBiLogger, genericParams, essentials = {} }) {
    __publicField(this, "newLoggerConfig");
    __publicField(this, "oldLogger");
    if (logger) {
      this.newLoggerConfig = { logger, genericParams: omit(genericParams, "msid") };
      return;
    }
    if (!isSSR()) {
      const biLoggerPromise = Promise.resolve(
        webBiLogger || import(
          /* webpackChunkName: "wix-ricos-bi-logger-fallback" */
          "@wix/web-bi-logger"
        )
      );
      this.oldLogger = biLoggerPromise.then((result) => {
        const biLogger = result.default?.default ? result.default : result;
        return biLogger.factory().updateDefaults({ ...genericParams, ...paramsToBiFields(essentials) }).logger();
      });
    }
  }
  log(func, params) {
    if (this.newLoggerConfig) {
      const logObject = func(params);
      const { params: eventParams, ...rest } = logObject;
      this.newLoggerConfig.logger.report?.({
        params: { ...this.newLoggerConfig.genericParams, ...eventParams },
        ...rest
      });
    } else if (this.oldLogger) {
      this.oldLogger.then((logger) => logger.report(func(params)));
    } else {
      console.error(`[RicosBILogger.ts:log] RicosBILogger was not initialized`);
    }
  }
}
export {
  RicosBILogger
};
//# sourceMappingURL=RicosBILogger.js.map
